import Combox from './js/Combox'
import './app.scss';

const combox = new Combox(document.querySelector('.communication_box'));



// WEBPACK FOOTER //
// ./src/app.js